import type { Rules } from "async-validator";
import type { ComposerTranslation } from "vue-i18n";
import { VALIDATION_REGEXP } from "~/core/constants/constants";

export function getUserValidationRules(t: ComposerTranslation): Rules {
  return {
    firstName: [
      {
        type: "string",
        required: true,
        message: t("user.firstNameRequiredError"),
        whitespace: true,
      },
      {
        type: "string",
        required: true,
        min: 1,
        max: 50,
        message: t("user.firstNameLengthError"),
        whitespace: true,
      },
      {
        type: "string",
        pattern: VALIDATION_REGEXP.NAME,
        message: t("user.firstNameFormatError"),
        whitespace: true,
      },
    ],
    lastName: [
      {
        type: "string",
        required: true,
        message: t("user.lastNameRequiredError"),
        whitespace: true,
      },
      {
        type: "string",
        min: 1,
        max: 50,
        message: t("user.lastNameLengthError"),
        whitespace: true,
      },
      {
        type: "string",
        pattern: VALIDATION_REGEXP.NAME,
        message: t("user.lastNameFormatError"),
        whitespace: true,
      },
    ],
    login: [
      {
        type: "string",
        required: true,
        message: t("user.loginRequiredError"),
      },
      {
        type: "string",
        min: 2,
        max: 50,
        message: t("user.loginLengthError"),
      },
      {
        type: "string",
        pattern: VALIDATION_REGEXP.LOGIN,
        message: t("user.loginFormatError"),
      },
    ],
    email: [
      {
        type: "string",
        required: true,
        message: t("user.emailRequiredError"),
      },
      {
        type: "string",
        pattern: VALIDATION_REGEXP.EMAIL,
        message: t("user.emailFormatError"),
      },
    ],
    language: [
      {
        type: "string",
        required: true,
        message: t("user.languageError"),
      },
    ],
  };
}
